import React, { useEffect } from 'react'
import { Link, usePage, useForm } from '@inertiajs/react'

import { toast } from 'react-toastify'

import Layout from '@/Shared/Layout'

import Form from './Shared/Form'

const Create = () => {
  const { hospitals, type, laundryItem } = usePage().props

  const { data, setData, errors, post, processing } = useForm({
    hospital_id: laundryItem
      ? laundryItem.laundry.hospital_id
      : typeof hospitals === 'object'
        ? null
        : hospitals,
    type,
    indent_no: laundryItem ? laundryItem.id : '',
    package: laundryItem ? laundryItem.laundry.package : '',
    is_feeder: laundryItem ? laundryItem.laundry.is_feeder : false,
    bed_sheet: '',
    blanket: '',
    pillow_cover: '',
    gown: '',
    curtain: '',
    table_cloth: '',
    washroom_towels: '',
    draw_sheet: '',
    ot_kit: '',
    ot_gown: '',
    apron_bearers: '',
    laundry_id: laundryItem?.laundry.id
  })

  useEffect(() => {
    Object.values(errors).map(error => {
      toast.error(error)
    })
  }, [errors])

  function handleSubmit(e) {
    e.preventDefault()
    post(route('laundry.store'))
  }

  return (
    <div>
      <h1 className="mb-8 text-3xl font-bold">
        <Link
          onClick={() => history.back()}
          className="text-indigo-600 hover:text-indigo-700"
        >
          {type.charAt(0).toUpperCase() + type.slice(1)}
        </Link>
        <span className="font-medium text-indigo-600"> /</span> Add Record
      </h1>

      <div className="max-w-3xl overflow-hidden rounded bg-white p-8 shadow">
        <h1 className="text-2xl font-semibold">Laundry Form</h1>

        <Form
          handleSubmit={handleSubmit}
          hospitals={hospitals}
          errors={errors}
          data={data}
          setData={setData}
          processing={processing}
        />
      </div>
    </div>
  )
}

Create.layout = page => <Layout title="Add HR Record" children={page} />

export default Create
